import { adModel,commonModels } from '@gatherstar/models';

export default () => {
    return {
        ...adModel,
        ...commonModels,
    }
};
